import { render, staticRenderFns } from "./OrdersObserved.vue?vue&type=template&id=ce90935e&"
import script from "./OrdersObserved.vue?vue&type=script&lang=js&"
export * from "./OrdersObserved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports